import { Component, OnInit, inject } from "@angular/core";
import { NavigationService } from "@tylertech/core-module";
import { ICustomViewComponent } from "@tylertech/custom-view";
import { AccountDetailViewModel, IInfoCardData } from "@tylertech/tyler-api-types";

@Component({
    selector: "project-account-search-detail-card",
    templateUrl: "./projectAccountSearchDetail.tmpl.html",
    styleUrls: [
        "./projectAccountSearchDetail.component.scss"
    ],
    standalone: false
})
export class ProjectAccountSearchDetailComponent implements OnInit, ICustomViewComponent<IInfoCardData>
{
    private readonly $navigationService = inject(NavigationService);

    readonly customDataBinding: IInfoCardData;

    get id(): string { return this.customDataBinding?.Id; }
    get item(): IInfoCardData { return this.customDataBinding; }

    isLoaded: boolean;
    link: string;
    totals: AccountDetailViewModel[];

    ngOnInit(): void
    {
        this.link = this.$navigationService.getLinkToApp("projectaccounts", { projectId: this.item.Id }) as string;
        this.totals = this.item.DataElements.find(x => x.Name === "Totals")?.Value as Array<AccountDetailViewModel>;
        this.isLoaded = true;
    }
}
